export default "__VITE_ASSET__YHw3xcXG__"